var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageNotFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.625V18.625H24V20.625H21V23.625H19V20.625H16V18.625H19V15.625H21ZM21.008 3.625C21.556 3.625 22 4.07 22 4.618V13.625H20V5.625H4V19.624L14 9.625L17 12.625V15.454L14 12.454L6.827 19.625H14V21.625H2.992C2.72881 21.6247 2.4765 21.52 2.29049 21.3338C2.10448 21.1476 2 20.8952 2 20.632V4.618C2.00183 4.35538 2.1069 4.10402 2.29251 3.91822C2.47813 3.73242 2.72938 3.62709 2.992 3.625H21.008ZM8 7.625C8.53043 7.625 9.03914 7.83571 9.41421 8.21079C9.78929 8.58586 10 9.09457 10 9.625C10 10.1554 9.78929 10.6641 9.41421 11.0392C9.03914 11.4143 8.53043 11.625 8 11.625C7.46957 11.625 6.96086 11.4143 6.58579 11.0392C6.21071 10.6641 6 10.1554 6 9.625C6 9.09457 6.21071 8.58586 6.58579 8.21079C6.96086 7.83571 7.46957 7.625 8 7.625Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFill);
export default __webpack_public_path__ + "static/media/image-not-fill.1e4dd88c46f862ac8bc199de1ca3ec78.svg";
export { ForwardRef as ReactComponent };